//imports
import { EditorState } from 'draft-js';
import moment from 'moment';
import * as yup from 'yup';
//constants, helper, interfaces
import {
  ADDED_SUGAR_TEXT,
  ARSENIC_TEXT,
  AVERAGE_PARTICLE_SIZE_TEXT,
  BIOTIN_TEXT,
  BORON_TEXT,
  BOTTLE_SIZE_TEXT,
  CADMIUM_TEXT,
  CALCIUM_TEXT,
  CALORIES_TEXT,
  CARBOHYDRATES_TEXT,
  CC_TEXT,
  CHOLESTEROL_TEXT,
  CHOLINE_TEXT,
  CITY_TEXT,
  COMMON_NAME_TEXT,
  COMPANY_NAME_TEXT,
  CONFIRM_NEW_PASSWORD_TEXT,
  CONFIRM_PASSWORD_MATCH,
  CONFIRM_PASSWORD_TEXT,
  CONVERSION_COST_TEXT,
  COST_TEXT,
  COUNTRY_OF_MANUFACTURING_TEXT,
  COUNTRY_OF_ORIGIN_TEXT,
  COUNTRY_TEXT,
  DEFINING_AMOUNT_TEXT,
  DIETARY_FIBER_TEXT,
  EMPTY_WEIGHT_TEXT,
  EXCIPIENT_LABEL_TEXT,
  EXCIPIENT_TEXT,
  FILING_PERCENTAGE_TEXT,
  FIRST_NAME_TEXT,
  FLOAT_4_REGEX,
  FLOAT_REGEX,
  FOLATE_TEXT,
  GUMMY_OVERAGE_TEXT,
  IODINE_TEXT,
  IRON_TEXT,
  LABEL_NAME_TEXT,
  LAST_NAME_TEXT,
  LEAD_TEXT,
  LID_SIZE_TEXT,
  LIMIT_UPTO_300_MSG,
  LOAD_ADD_TEXT,
  LOAD_ADD_UNIT_TEXT,
  LOH_COST_TEXT,
  LOSS_ON_DRYING_TEXT,
  MAGNESIUM_TEXT,
  MAX_STAFF,
  MAX_TEXT,
  MERCURY_TEXT,
  MG_PER_SERVING_TEXT,
  MIN_TEXT,
  MOISTURE_IN_GRAMS_TEXT,
  MONOUNSATURATED_FAT_TEXT,
  NAME_MUST_CONTAIN_ONLY_LETTERS_AND_SPACE_TEXT,
  NAME_TEXT,
  NATURE_TEXT,
  NEW_PASSWORD_TEXT,
  NIACIN_TEXT,
  NUTRIENT_INFO_REGEX,
  OLD_PASSWORD_TEXT,
  ORGANIC_NUMERICAL_TEXT,
  ORGANIZATION_NAME_TEXT,
  OZ_TEXT,
  PASSWORD_REGEX,
  PASSWORD_TEXT,
  PLAN_TEXT,
  PASSWORD_VALIDATION_MESSAGE,
  PERCENTAGE_TEXT,
  PER_KG_COST_TEXT,
  PHONE_TEXT,
  POLYUNSATURATED_FAT_TEXT,
  POTASSIUM_TEXT,
  PRICE_TEXT,
  PRIMARY_CATEGORY_TEXT,
  PRODUCT_FORMULATION_SYRUP_TYPE_TEXT,
  PRODUCT_FORMULATION_TEXT,
  PRODUCT_INGREDIENT_TEXT,
  PRODUCT_SIZE_TEXT,
  PRODUCT_TYPE_TEXT,
  PROTEIN_TEXT,
  QT_PER_MG_TEXT,
  RIBOFLAVIN_TEXT,
  SAND_COATING_TEXT,
  SAND_COMPONENT_TEXT,
  SATURATED_FAT_TEXT,
  SECONDARY_CATEGORY_TEXT,
  SERVING_SIZE_TEXT,
  SHELF_LIFE_TEXT,
  SIZE_TEXT,
  SODIUM_TEXT,
  STATE_TEXT,
  STRIPE_CARD_NAME_REGEX,
  SUB_PRODUCT_TYPE_TEXT,
  SUGGESTED_OVERAGE_TEXT,
  SUGGESTED_SUPPLIER_TEXT,
  SWEETENER_COMPONENT_TEXT,
  TERMS_AND_CONDITIONS_TEXT,
  TEXT_REGEX,
  THIAMIN_TEXT,
  TOTAL_FAT_TEXT,
  TOTAL_SUGARS_TEXT,
  TRANS_FAT_TEXT,
  TRIAL_END_DATE_TEXT,
  TRIAL_END_MAX_MESSAGE,
  TRIAL_END_MIN_MESSAGE,
  TRIAL_MAX_DAYS,
  TYPE_TEXT,
  VITAMIN_A_TEXT,
  VITAMIN_B12_TEXT,
  VITAMIN_B6_TEXT,
  VITAMIN_C_TEXT,
  VITAMIN_D_TEXT,
  VITAMIN_E_TEXT,
  VITAMIN_K2_TEXT,
  WEIGHT_TEXT,
  ZINC_TEXT,
  PROBIOTIC_TEXT,
  selectTypeInitialValues,
  OTP_TEXT,
  SIX_DIGIT_OTP_REGEX,
  OPT_MUST_BE_SIX_DIGIT_MESSAGE,
  COST_PER_KG_TEXT,
  DESCRIPTION_TEXT,
  CAPACITY_TEXT,
  DENSITY_TEXT,
  SUPPLIER_TEXT,
  CAPSULE_TYPE_TEXT,
  UNIT_TEXT,
  PREGNANT_AND_LACTATING_WOMEN_TEXT,
  INFANTS_TEXT,
  ADULTS_AND_CHILDREN_TEXT,
  CHILDREN_1_TO_3_YEARS_TEXT,
  FOOD_COMPONENT_TEXT,
} from 'constants/index';
import {
  AddBottleCapacityFormType,
  AddBottlePriceFormType,
  AddBottleSizeFormType,
  AddExcipientFormType,
  AddExcipientLabelFormType,
  AddExcipientTypeFormType,
  AddProductFormulationTypeForm,
  AddProductSizeFormType,
  AddProductTypeFormType,
  AddServingSizeFormType,
  AddSubProductTypeFormType,
  AddSweetenerComponentFormType,
  AddSweetenerElementFormType,
  AddSweetenerSystemFormType,
  AdditionalContactFormType,
  AdditionalContactSelectType,
  AllergensCardType,
  CarrierSelectType,
  CarriersFormType,
  CoatingFormulationComponentFormType,
  ContactFormType,
  ForgotPasswordInput,
  ForgotUserInput,
  FormulationSyrupTypeFormType,
  HeavyMetalsFormType,
  IngredientBasicInfoCardType,
  IngredientCostInfoCardType,
  IngredientCountriesCardType,
  IngredientDensityCardType,
  IngredientSupplierCardType,
  IngredientSyrupTypeFormType,
  LoginUserInput,
  NutrientsCardType,
  NutrientsTypeObject,
  OrganizationFormType,
  ProductExcipientFormType,
  ProductIngredientFormType,
  SandCoatingFormType,
  SandCoatingFormulationFormType,
  SandComponentFormType,
  SignupUserInput,
  StaffRoleFormType,
  StripeFormType,
  SubComponentSelectType,
  SubComponentsFormType,
  SupplierFormType,
  SyrupBaseIngredientBasicInfoCardType,
  SyrupBaseIngredientCostInfoCardType,
  UpdatePasswordFormType,
  UpdateUserProfileType,
  UserFormType,
  YupSchemaShape,
  AddressFormType,
  VerifyOTPInput,
  BaseCoatingFormType,
  CapsuleTypeFormType,
  CapsulePriceFormType,
  DvConstraintsFormType,
} from 'interfaces';
import {
  convertEditorStateToHtml,
  convertHtmlToText,
  invalidFloat4Message,
  invalidFloatMessage,
  invalidMessage,
  invalidPhoneMessage,
  maxFieldMessage,
  maxMessage,
  minFieldMessage,
  requiredMessage,
} from 'lib/helper';
import {
  isEmail,
  notRequiredFloat,
  notRequiredMatches,
  notRequiredPercentage,
  notRequiredPhone,
  notRequiredPositiveNumber,
  nutrientInfoSchema,
  overageSchema,
  percentageRequired,
  positiveNumberMax,
  potencySchema,
  requiredFloat,
  requiredInteger,
  requiredMatches,
  requiredPositiveNumber,
  selectorSchema,
  zipCodeSchema,
} from './commonValidations';

export const addressSchema: yup.ObjectSchema<AddressFormType> = yup.object().shape({
  address1: yup.string().trim().default(''),
  address2: yup.string().trim().default(''),
  city: yup.string().trim().default(''),
  zip: zipCodeSchema().default(''),
  state: selectorSchema(STATE_TEXT, false).default(selectTypeInitialValues),
  country: selectorSchema(COUNTRY_TEXT, false).default(selectTypeInitialValues),
});

export const heavyMetal = (label: string, isRequired: boolean = false) =>
  isRequired
    ? requiredMatches(label, invalidFloatMessage(label), NUTRIENT_INFO_REGEX)
    : notRequiredMatches(invalidFloatMessage(label), NUTRIENT_INFO_REGEX);

export const loginSchema = yup.object().shape<YupSchemaShape<LoginUserInput>>({
  email: isEmail(),
  password: yup
    .string()
    .required(requiredMessage(PASSWORD_TEXT))
    .matches(PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE),
  rememberMe: yup.boolean().default(false),
});

export const verifyOTPSchema = yup.object().shape<YupSchemaShape<VerifyOTPInput>>({
  otp: yup
    .string()
    .required(requiredMessage(OTP_TEXT))
    .matches(SIX_DIGIT_OTP_REGEX, OPT_MUST_BE_SIX_DIGIT_MESSAGE),
});

export const stripePaymentSchema = yup.object().shape<YupSchemaShape<StripeFormType>>({
  name: yup
    .string()
    .required(requiredMessage(NAME_TEXT))
    .matches(STRIPE_CARD_NAME_REGEX, NAME_MUST_CONTAIN_ONLY_LETTERS_AND_SPACE_TEXT),
});

export const forgotSchema = yup.object().shape<YupSchemaShape<ForgotUserInput>>({
  email: isEmail(),
});

export const forgotPasswordSchema = yup.object().shape<YupSchemaShape<ForgotPasswordInput>>({
  password: yup
    .string()
    .required(requiredMessage(PASSWORD_TEXT))
    .matches(PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE),
  confirmPassword: yup
    .string()
    .required(requiredMessage(CONFIRM_PASSWORD_TEXT))
    .oneOf([yup.ref('password'), ''], CONFIRM_PASSWORD_MATCH),
});

export const signupSchema: yup.ObjectSchema<SignupUserInput> = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required(requiredMessage(FIRST_NAME_TEXT))
    .max(300, maxMessage(FIRST_NAME_TEXT, 300)),
  lastName: yup
    .string()
    .trim()
    .required(requiredMessage(LAST_NAME_TEXT))
    .max(300, maxMessage(LAST_NAME_TEXT, 300)),
  organizationName: yup
    .string()
    .trim()
    .required(requiredMessage(ORGANIZATION_NAME_TEXT))
    .max(300, maxMessage(ORGANIZATION_NAME_TEXT, 300)),
  email: isEmail(),
  termsAndConditions: yup
    .boolean()
    .test('terms-and-conditions', requiredMessage(TERMS_AND_CONDITIONS_TEXT), (value) => value)
    .default(false),
});

export const organizationSchema = yup.object().shape<YupSchemaShape<OrganizationFormType>>({
  organizationName: yup.string().trim().required(requiredMessage(ORGANIZATION_NAME_TEXT)).max(300),
  maxUser: requiredInteger(MAX_STAFF, 4, true),
});

export const roleSchema = yup.object().shape<YupSchemaShape<StaffRoleFormType>>({
  role: yup.string(),
});

export const updatePasswordSchema = yup.object().shape<YupSchemaShape<UpdatePasswordFormType>>({
  password: yup
    .string()
    .required(requiredMessage(PASSWORD_TEXT))
    .matches(PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE),
});

export const userSchema = yup.object().shape<YupSchemaShape<UserFormType>>({
  firstName: yup.string().trim().required(requiredMessage(FIRST_NAME_TEXT)),
  lastName: yup.string().trim().required(requiredMessage(LAST_NAME_TEXT)),
  phone: notRequiredPhone(invalidPhoneMessage(PHONE_TEXT)),
  email: isEmail(),
});

export const addNewUserSchema = userSchema.concat(updatePasswordSchema).concat(organizationSchema);

export const editUserSchema = userSchema.concat(organizationSchema);

export const addNewStaffSchema = userSchema.concat(updatePasswordSchema).concat(roleSchema);

export const updateStaffSchema = userSchema.concat(roleSchema);

export const addOrgStaffSchema = addNewStaffSchema.concat(
  yup.object().shape({
    priceId: yup.string().required(requiredMessage(PLAN_TEXT)),
    trialEnd: yup
      .date()
      .typeError(requiredMessage(TRIAL_END_DATE_TEXT))
      .required(requiredMessage(TRIAL_END_DATE_TEXT))
      .test('', TRIAL_END_MIN_MESSAGE, (value) => !value || moment(value).isAfter(moment(), 'day'))
      .test(
        '',
        TRIAL_END_MAX_MESSAGE,
        (value) => !value || moment(value).isSameOrBefore(moment().add(TRIAL_MAX_DAYS, 'days'), 'day'),
      ),
  }),
);

export const htmlValidation = (label: string) => {
  return yup.mixed().test('', maxMessage(label, 500), (val) => {
    if (val) {
      const html = convertEditorStateToHtml(val as EditorState);
      const txt = convertHtmlToText(html);
      return txt?.length <= 500;
    }
    return false;
  });
};

export const ingredientBasicInfoCardSchema = yup.object().shape<YupSchemaShape<IngredientBasicInfoCardType>>({
  latinName: htmlValidation(LABEL_NAME_TEXT),
  tradeMarkName: yup.string().trim().max(300, LIMIT_UPTO_300_MSG),
  scientificName: yup.string().trim().max(300, LIMIT_UPTO_300_MSG),
  type: yup.array().of(yup.string()),
  productTypes: yup.array().of(yup.string()).min(1, minFieldMessage(PRODUCT_TYPE_TEXT, 1)),
  category: selectorSchema(PRIMARY_CATEGORY_TEXT),
  name: yup.string().trim().required(requiredMessage(COMMON_NAME_TEXT)).max(300, LIMIT_UPTO_300_MSG),
  subCategory: selectorSchema(SECONDARY_CATEGORY_TEXT, false),
  isOrganic: yup.boolean(),
});

export const syrupBaseIngredientBasicInfoCardSchema = yup
  .object()
  .shape<YupSchemaShape<SyrupBaseIngredientBasicInfoCardType>>({
    name: yup.string().trim().required(requiredMessage(COMMON_NAME_TEXT)).max(300, LIMIT_UPTO_300_MSG),
    type: yup.array().of(yup.string()),
    productFormulationSyrupType: selectorSchema(PRODUCT_FORMULATION_SYRUP_TYPE_TEXT),
  });

export const ingredientCostInfoCardSchema = yup.object().shape<YupSchemaShape<IngredientCostInfoCardType>>({
  potency: potencySchema(),
  shelfLife: notRequiredPositiveNumber(SHELF_LIFE_TEXT, 5),
  suggestedOverage: overageSchema(SUGGESTED_OVERAGE_TEXT),
  gummyOverage: overageSchema(GUMMY_OVERAGE_TEXT),
  cost: requiredPositiveNumber(COST_TEXT, 15),
  amount: yup.string().required(requiredMessage(DEFINING_AMOUNT_TEXT)),
  proBiotic: notRequiredPositiveNumber(PROBIOTIC_TEXT, 6),
});

export const syrupBaseIngredientCostInfoCardSchema = yup
  .object()
  .shape<YupSchemaShape<SyrupBaseIngredientCostInfoCardType>>({
    gummyOverage: notRequiredPercentage(GUMMY_OVERAGE_TEXT),
    amount: yup.string().required(requiredMessage(DEFINING_AMOUNT_TEXT)),
  });

export const ingredientSupplierCardSchema = yup.object().shape<YupSchemaShape<IngredientSupplierCardType>>({
  primarySupplier: selectorSchema(SUGGESTED_SUPPLIER_TEXT, false),
  secondarySupplier: selectorSchema(SUGGESTED_SUPPLIER_TEXT, false),
  tertiarySupplier: selectorSchema(SUGGESTED_SUPPLIER_TEXT, false),
});

export const ingredientCountriesCardSchema = yup.object().shape<YupSchemaShape<IngredientCountriesCardType>>({
  manufacturingCountry: selectorSchema(COUNTRY_OF_MANUFACTURING_TEXT, false),
  originCountry: selectorSchema(COUNTRY_OF_ORIGIN_TEXT, false),
});

export const ingredientDensityCardSchema = yup.object().shape<YupSchemaShape<IngredientDensityCardType>>({
  density: nutrientInfoSchema(DENSITY_TEXT),
  averageParticleSize: nutrientInfoSchema(AVERAGE_PARTICLE_SIZE_TEXT),
  lossOnDrying: heavyMetal(LOSS_ON_DRYING_TEXT),
});

export const allergensCardSchema = yup.object().shape<YupSchemaShape<AllergensCardType>>({
  allergens: yup.array().of(yup.string()),
});

export const nutrientsCardSchema = yup.object().shape<YupSchemaShape<NutrientsTypeObject>>({
  zinc: nutrientInfoSchema(ZINC_TEXT),
  addedSugar: nutrientInfoSchema(ADDED_SUGAR_TEXT),
  biotin: nutrientInfoSchema(BIOTIN_TEXT),
  boron: nutrientInfoSchema(BORON_TEXT),
  calcium: nutrientInfoSchema(CALCIUM_TEXT),
  calories: nutrientInfoSchema(CALORIES_TEXT),
  carbohydrates: nutrientInfoSchema(CARBOHYDRATES_TEXT),
  cholesterol: nutrientInfoSchema(CHOLESTEROL_TEXT),
  choline: nutrientInfoSchema(CHOLINE_TEXT),
  dietaryFiber: nutrientInfoSchema(DIETARY_FIBER_TEXT),
  folate: nutrientInfoSchema(FOLATE_TEXT),
  iodine: nutrientInfoSchema(IODINE_TEXT),
  iron: nutrientInfoSchema(IRON_TEXT),
  magnesium: nutrientInfoSchema(MAGNESIUM_TEXT),
  moisture: nutrientInfoSchema(MOISTURE_IN_GRAMS_TEXT),
  monounsaturatedFat: nutrientInfoSchema(MONOUNSATURATED_FAT_TEXT),
  niacin: nutrientInfoSchema(NIACIN_TEXT),
  organic: nutrientInfoSchema(ORGANIC_NUMERICAL_TEXT),
  polyunsaturatedFat: nutrientInfoSchema(POLYUNSATURATED_FAT_TEXT),
  potassium: nutrientInfoSchema(POTASSIUM_TEXT),
  protein: nutrientInfoSchema(PROTEIN_TEXT),
  riboflavin: nutrientInfoSchema(RIBOFLAVIN_TEXT),
  saturatedFat: nutrientInfoSchema(SATURATED_FAT_TEXT),
  sodium: nutrientInfoSchema(SODIUM_TEXT),
  thiamin: nutrientInfoSchema(THIAMIN_TEXT),
  totalFat: nutrientInfoSchema(TOTAL_FAT_TEXT),
  totalSugars: nutrientInfoSchema(TOTAL_SUGARS_TEXT),
  transFat: nutrientInfoSchema(TRANS_FAT_TEXT),
  vitaminA: nutrientInfoSchema(VITAMIN_A_TEXT),
  vitaminB12: nutrientInfoSchema(VITAMIN_B12_TEXT),
  vitaminB6: nutrientInfoSchema(VITAMIN_B6_TEXT),
  vitaminC: nutrientInfoSchema(VITAMIN_C_TEXT),
  vitaminD: nutrientInfoSchema(VITAMIN_D_TEXT),
  vitaminE: nutrientInfoSchema(VITAMIN_E_TEXT),
  vitaminK2: nutrientInfoSchema(VITAMIN_K2_TEXT),
  chloride: yup.string(),
  chromium: yup.string(),
  copper: yup.string(),
  manganese: yup.string(),
  molybdenum: yup.string(),
  pantothenicAcid: yup.string(),
  phosphorus: yup.string(),
  selenium: yup.string(),
});

export const heavyMetalSchema = yup.object().shape<YupSchemaShape<HeavyMetalsFormType>>({
  arsenic: heavyMetal(ARSENIC_TEXT),
  cadmium: heavyMetal(CADMIUM_TEXT),
  lead: heavyMetal(LEAD_TEXT),
  mercury: heavyMetal(MERCURY_TEXT),
});

export const nutrientsSchema = yup.object().shape<YupSchemaShape<NutrientsCardType>>({
  ingredientInfo: nutrientsCardSchema,
});

const carriersCardSchema = yup.object().shape<YupSchemaShape<CarrierSelectType>>({
  excipient: selectorSchema(NAME_TEXT),
  percentage: percentageRequired(PERCENTAGE_TEXT),
});

export const carriersSchema = yup.object().shape<YupSchemaShape<CarriersFormType>>({
  carriers: yup.array().of(carriersCardSchema),
});

const subComponentCardSchema = yup.object().shape<YupSchemaShape<SubComponentSelectType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  percentage: percentageRequired(PERCENTAGE_TEXT),
});

export const subComponentSchema = yup.object().shape<YupSchemaShape<SubComponentsFormType>>({
  subComponents: yup.array().of(subComponentCardSchema),
});

export const addNewIngredientSchema = ingredientBasicInfoCardSchema
  .concat(allergensCardSchema)
  .concat(nutrientsSchema)
  .concat(ingredientCostInfoCardSchema)
  .concat(ingredientSupplierCardSchema)
  .concat(ingredientCountriesCardSchema)
  .concat(heavyMetalSchema)
  .concat(ingredientDensityCardSchema)
  .concat(carriersSchema)
  .concat(subComponentSchema);

export const addNewSyrupBaseIngredientSchema = syrupBaseIngredientBasicInfoCardSchema
  .concat(heavyMetalSchema)
  .concat(nutrientsSchema);

export const changePasswordSchema = yup.object({
  oldPassword: yup
    .string()
    .required(requiredMessage(OLD_PASSWORD_TEXT))
    .matches(PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE),
  newPassword: yup
    .string()
    .required(requiredMessage(NEW_PASSWORD_TEXT))
    .matches(PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE),
  conPassword: yup
    .string()
    .required(requiredMessage(CONFIRM_NEW_PASSWORD_TEXT))
    .oneOf([yup.ref('newPassword'), ''], CONFIRM_PASSWORD_MATCH),
});

export const updateUserProfileSchema: yup.ObjectSchema<UpdateUserProfileType> = yup.object().shape({
  firstName: yup.string().trim().required(requiredMessage(FIRST_NAME_TEXT)),
  lastName: yup.string().trim().required(requiredMessage(LAST_NAME_TEXT)),
  phone: notRequiredPhone(invalidPhoneMessage(PHONE_TEXT)).default(''),
  orgName: yup.string().trim().optional().default(''),
  email: isEmail().default(''),
  address: addressSchema,
});

export const contactSchema = yup.object().shape<YupSchemaShape<ContactFormType>>({
  designation: yup.string(),
  address1: yup.string().trim(),
  address2: yup.string().trim(),
  phoneNo: yup.string().trim(),
  state: selectorSchema(STATE_TEXT, false),
  country: selectorSchema(COUNTRY_TEXT, false),
  email: isEmail(),
  name: yup.string().required(requiredMessage(NAME_TEXT)),
  city: notRequiredMatches(invalidMessage(CITY_TEXT), TEXT_REGEX),
  zipCode: zipCodeSchema(),
});

const additionalContactsCardSchema = yup.object().shape<YupSchemaShape<AdditionalContactSelectType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(100, maxMessage(NAME_TEXT, 100)),

  email: isEmail(true),
});

export const additionalContactsSchema = yup.object().shape<YupSchemaShape<AdditionalContactFormType>>({
  additionalContacts: yup.array().of(additionalContactsCardSchema),
});

export const supplierFormSchema = yup.object().shape<YupSchemaShape<SupplierFormType>>({
  companyName: yup.string().trim().required(requiredMessage(COMPANY_NAME_TEXT)),
  description: yup.string(),
});

export const supplierSchema = supplierFormSchema.concat(contactSchema).concat(additionalContactsSchema);

export const updateProductTypeSchema = yup.object().shape<YupSchemaShape<AddProductTypeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  propagateToOrganizations: yup.boolean(),
});

export const updateSubProductTypeSchema = yup.object().shape<YupSchemaShape<AddSubProductTypeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
});

export const addSubProductTypeSchema = yup.object().shape<YupSchemaShape<AddSubProductTypeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  productType: selectorSchema(PRODUCT_TYPE_TEXT),
});

export const updateProductSizeSchema = yup.object().shape<YupSchemaShape<AddProductSizeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  emptyWtMg: notRequiredPositiveNumber(EMPTY_WEIGHT_TEXT, 5, true),
  min: notRequiredPositiveNumber(MIN_TEXT, 11, true),
  max: notRequiredPositiveNumber(MAX_TEXT, 11, true),
  productType: selectorSchema(PRODUCT_TYPE_TEXT),
});

export const updateProductFormulationTypeSchema = yup
  .object()
  .shape<YupSchemaShape<AddProductFormulationTypeForm>>({
    name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
    conversionCost: requiredPositiveNumber(CONVERSION_COST_TEXT, 5, true),
    innerComponentCost: yup.string(),
    isInnerCapTab: yup.boolean(),
    lohInside: yup.string(),
    productType: selectorSchema(PRODUCT_TYPE_TEXT),
    propagateToOrganizations: yup.boolean(),
  });

export const updateExcipientSchema = yup.object().shape<YupSchemaShape<AddExcipientFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
});
export const updateExcipientLabelSchema = yup.object().shape<YupSchemaShape<AddExcipientLabelFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
});

export const updateExcipientTypeSchema = yup.object().shape<YupSchemaShape<AddExcipientTypeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  perKgCost: requiredFloat(PER_KG_COST_TEXT, 1, 5),
  loadAdd: requiredFloat(LOAD_ADD_TEXT, 1, 5),
  loadAddUnit: yup.string().required(requiredMessage(LOAD_ADD_UNIT_TEXT)),
  productType: selectorSchema(PRODUCT_TYPE_TEXT),
  excipientLabel: yup.string().required(requiredMessage(EXCIPIENT_LABEL_TEXT)),
});

export const productExcipientTypeSchema = yup.object().shape<YupSchemaShape<ProductExcipientFormType>>({
  perKgCost: requiredFloat(PER_KG_COST_TEXT, 1, 6),
  percentage: percentageRequired(PERCENTAGE_TEXT),
  excipient: selectorSchema(EXCIPIENT_TEXT),
  suppliers: yup
    .array()
    .of(selectorSchema(SUGGESTED_SUPPLIER_TEXT))
    .max(3, maxFieldMessage(SUGGESTED_SUPPLIER_TEXT, 3)),
});

export const coatingFormulationComponentSchema = yup
  .object()
  .shape<YupSchemaShape<CoatingFormulationComponentFormType>>({
    weight: requiredPositiveNumber(WEIGHT_TEXT, 9),
    sandComponent: selectorSchema(SAND_COMPONENT_TEXT),
    sandCoatingFormulation: selectorSchema(SAND_COATING_TEXT, false),
  });

export const updateBottleSizeTypeSchema = yup.object().shape<YupSchemaShape<AddBottleSizeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  lidSize: notRequiredFloat(LID_SIZE_TEXT, 1, 5),
  cc: notRequiredFloat(CC_TEXT, 1, 5),
  oz: notRequiredFloat(OZ_TEXT, 1, 5),
  productTypes: yup
    .array()
    .of(selectorSchema(PRODUCT_TYPE_TEXT))
    .min(1, minFieldMessage(PRODUCT_TYPE_TEXT, 1)),
});

export const updateServingSizeTypeSchema = yup.object().shape<YupSchemaShape<AddServingSizeFormType>>({
  size: positiveNumberMax(SIZE_TEXT, 5000),
});

export const updateBottlePriceTypeSchema = yup.object().shape<YupSchemaShape<AddBottlePriceFormType>>({
  price: requiredFloat(PRICE_TEXT),
  bottleSize: selectorSchema(BOTTLE_SIZE_TEXT),
  type: yup.string().trim().required(requiredMessage(TYPE_TEXT)),
  suppliers: yup
    .array()
    .of(selectorSchema(SUGGESTED_SUPPLIER_TEXT))
    .min(1, minFieldMessage(SUGGESTED_SUPPLIER_TEXT, 1))
    .max(3, maxMessage(SUGGESTED_SUPPLIER_TEXT, 3)),
});

export const bottleCapacityTypeSchema = yup.object().shape<YupSchemaShape<AddBottleCapacityFormType>>({
  lohCost: requiredFloat(LOH_COST_TEXT),
  fillingPercentage: notRequiredPercentage(FILING_PERCENTAGE_TEXT),
  bottleSize: selectorSchema(BOTTLE_SIZE_TEXT),
  productType: selectorSchema(PRODUCT_TYPE_TEXT),
  productSize: selectorSchema(PRODUCT_SIZE_TEXT),
  servingSize: selectorSchema(SERVING_SIZE_TEXT, false),
});

export const updateSweetenerSystemTypeSchema = yup
  .object()
  .shape<YupSchemaShape<AddSweetenerSystemFormType>>({
    name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
    nature: yup.string().trim().required(requiredMessage(NATURE_TEXT)),
    size: yup.string().trim().required(requiredMessage(SIZE_TEXT)),
    productType: selectorSchema(PRODUCT_TYPE_TEXT),
    costPerServing: requiredPositiveNumber(COST_TEXT, 9),
    mgPerServing: requiredPositiveNumber(MG_PER_SERVING_TEXT, 9),
  });

export const updateSweetenerComponentTypeSchema = yup
  .object()
  .shape<YupSchemaShape<AddSweetenerComponentFormType>>({
    name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
    costPerKg: requiredPositiveNumber(PER_KG_COST_TEXT, 9),
  });

export const productIngredientSchema = yup.object().shape<YupSchemaShape<ProductIngredientFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(100, maxMessage(NAME_TEXT, 100)),
});

export const sandCoatingSchema = yup.object().shape<YupSchemaShape<SandCoatingFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(50, maxMessage(NAME_TEXT, 50)),
});

export const sandCoatingFormulationSchema = yup
  .object()
  .shape<YupSchemaShape<SandCoatingFormulationFormType>>({
    sandCoating: selectorSchema(SAND_COATING_TEXT),
    productType: selectorSchema(PRODUCT_TYPE_TEXT),
    productSize: selectorSchema(PRODUCT_SIZE_TEXT),
    weight: requiredPositiveNumber(WEIGHT_TEXT, 9).test('00.00', invalidFloatMessage(WEIGHT_TEXT), (value) =>
      value ? FLOAT_REGEX.test(value) : true,
    ),
    cost: requiredPositiveNumber(COST_TEXT, 9).test('00.00000', invalidFloat4Message(COST_TEXT), (value) =>
      value ? FLOAT_4_REGEX.test(value) : true,
    ),
  });

export const sandComponentSchema = yup.object().shape<YupSchemaShape<SandComponentFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(100, maxMessage(NAME_TEXT, 100)),
});

export const updateSweetenerElementTypeSchema = yup
  .object()
  .shape<YupSchemaShape<AddSweetenerElementFormType>>({
    qtPerMg: requiredPositiveNumber(QT_PER_MG_TEXT, 9),
    sweetenerComponent: selectorSchema(SWEETENER_COMPONENT_TEXT),
  });

export const formulationSyrupTypeSchema = yup.object().shape<YupSchemaShape<FormulationSyrupTypeFormType>>({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(100, maxMessage(NAME_TEXT, 100)),
  cost: requiredPositiveNumber(COST_TEXT, 9),
  weight: requiredPositiveNumber(WEIGHT_TEXT, 9),
  productType: selectorSchema(PRODUCT_TYPE_TEXT),
  productSize: selectorSchema(PRODUCT_SIZE_TEXT),
  subProductType: selectorSchema(SUB_PRODUCT_TYPE_TEXT, false),
  productFormulationType: selectorSchema(PRODUCT_FORMULATION_TEXT),
});

export const ingredientSyrupTypeSchema = yup.object().shape<YupSchemaShape<IngredientSyrupTypeFormType>>({
  productIngredient: selectorSchema(PRODUCT_INGREDIENT_TEXT),
  percentage: percentageRequired(),
});

export const capsuleTypeSchema: yup.ObjectSchema<CapsuleTypeFormType> = yup.object().shape({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)),
  description: yup.string().trim().required(requiredMessage(DESCRIPTION_TEXT)),
});

export const capsulePriceSchema: yup.ObjectSchema<CapsulePriceFormType> = yup.object().shape({
  price: positiveNumberMax(PRICE_TEXT),
  capacity: positiveNumberMax(CAPACITY_TEXT),

  density: selectorSchema(DENSITY_TEXT),
  supplier: selectorSchema(SUPPLIER_TEXT),
  productSize: selectorSchema(PRODUCT_SIZE_TEXT),
  capsuleType: selectorSchema(CAPSULE_TYPE_TEXT),
});

export const baseCoatingSchema: yup.ObjectSchema<BaseCoatingFormType> = yup.object().shape({
  loadAdd: percentageRequired(LOAD_ADD_TEXT),
  productType: selectorSchema(PRODUCT_TYPE_TEXT),
  costPerKg: requiredFloat(COST_PER_KG_TEXT, 1, 5),
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(100, maxMessage(NAME_TEXT, 100)),
});

export const dvConstraintsSchema: yup.ObjectSchema<DvConstraintsFormType> = yup.object().shape({
  name: yup.string().trim().required(requiredMessage(NAME_TEXT)).max(100, maxMessage(NAME_TEXT, 100)),
  foodComponent: yup
    .string()
    .trim()
    .required(requiredMessage(FOOD_COMPONENT_TEXT))
    .max(100, maxMessage(FOOD_COMPONENT_TEXT, 100)),
  infants: requiredFloat(INFANTS_TEXT, 0, 6),
  adultsAndChildren: requiredFloat(ADULTS_AND_CHILDREN_TEXT, 0, 6),
  children1To3Years: requiredFloat(CHILDREN_1_TO_3_YEARS_TEXT, 0, 6),
  pregnantAndLactatingWomen: requiredFloat(PREGNANT_AND_LACTATING_WOMEN_TEXT, 0, 6),
  unit: yup.string().required(requiredMessage(UNIT_TEXT)),
});

export * from './formulaValidation';
